<template>
  <a v-bind="linkProps" class="ProductResourceLink">
    {{ resource.title }}
    <span class="icon" v-html="arrowRightSvg"></span>
  </a>
</template>

<script setup>
import { inject } from 'vue'

import formatString from '~/lib/formatString.js'
import arrowRightSvg from '~/assets/ui/link-arrow-right.svg?raw'

const { guidePathPattern } = inject('context')

const { text, resource } = defineProps({
  text: String,
  resource: Object,
})

const linkPropDefs = {
  'download': {
    href: resource.url,
    target: '_blank',
  },
  'guide': {
    href: formatString(guidePathPattern, resource)
  },
}

const linkProps = linkPropDefs[resource._type]
</script>

<style scoped>
.ProductResourceLink {
  display: inline-block;
  font-weight: 400;
  font-size: var(--font-size-3);
  line-height: 1.3;
  color: var(--brand-color);
  transition: color 0.15s;
}

.ProductResourceLink:hover {
  color: #0074C2;
}

.ProductResourceLink:focus {
  color: #23558C;
}

.icon {
  display: inline-block;
  margin-left: 0.33em;
  position: relative;
  left: 0;
  transition: left 0.15s;
}

.ProductResourceLink:hover .icon {
  left: 3px;
}
</style>
